import { useDispatch, useSelector } from 'react-redux'

import ErrorAlert from 'components/error/alert'
import { errorSelector } from 'selectors/error'
import { dismissGeneralError } from 'actions/errors'
import { fetchFailedCalendars } from 'actions/calendar'

const CalendarError = () => {
  const dispatch = useDispatch()
  const error = useSelector(errorSelector)

  if (!error) return null

  const dismissError = () => {
    dispatch(dismissGeneralError())
  }

  const retry = () => {
    dispatch(dismissGeneralError())
    dispatch(fetchFailedCalendars())
  }

  return (
    <ErrorAlert
      error={error}
      buttonClick={retry}
      dismissError={dismissError}
    />
  )
}

export default CalendarError
